import React, { forwardRef, useMemo } from 'react';
import { PrintLabel } from './PrintLabel.component';
import type { LabelsData, LabelBag } from '../../hooks/get-labels-by-date.hook';

const containerStyle = {
  color: 'black',
  display: 'flex' as const,
  height: '100%',
  justifyContent: 'center' as const,
  alignItems: 'center' as const,
  pageBreakAfter: 'always' as const,
};

const headerStyle = {
  fontSize: '40px',
  lineHeight: '40px',
  textAlign: 'center' as const,
  textTransform: 'uppercase' as const,
};

function BasketLabelsSection({ baskets }: { baskets: LabelBag[] }) {
  if (baskets.length === 0) return null;

  return (
    <>
      <div style={containerStyle}>
        <p style={headerStyle}>Les paniers bio</p>
      </div>
      {baskets.map((label, index) => (
        <PrintLabel key={index} label={label} />
      ))}
    </>
  );
}

function ProductLabelsByZipSection({ products }: { products: LabelBag[] }) {
  const labelsByZip = useMemo(() => {
    return products.reduce<Record<string, LabelBag[]>>((acc, label) => {
      if (!acc[label.zip]) acc[label.zip] = [];
      acc[label.zip].push(label);
      return acc;
    }, {});
  }, [products]);

  if (products.length === 0) return null;

  return (
    <>
      <div style={containerStyle}>
        <p style={headerStyle}>Autres</p>
      </div>
      {Object.entries(labelsByZip).map(([zip, labels]) => (
        <React.Fragment key={zip}>
          <div style={containerStyle}>
            <p style={headerStyle}>{zip}</p>
          </div>
          {labels.map((label, index) => (
            <PrintLabel key={index} label={label} />
          ))}
        </React.Fragment>
      ))}
    </>
  );
}

interface PrintLabelsContainerProps {
  labels: LabelsData | null;
}

export const PrintLabelsContainer = forwardRef<HTMLDivElement, PrintLabelsContainerProps>(
  function PrintLabelsContainer({ labels }, ref) {
    if (!labels) return null;

    return (
      <div style={{ position: 'absolute', overflow: 'hidden', height: 0, width: 0 }}>
        <div ref={ref} style={{ width: '234px' }}>
          <BasketLabelsSection baskets={labels.baskets} />
          <ProductLabelsByZipSection products={labels.products} />
        </div>
      </div>
    );
  },
);
